<template>
  <v-container class="pt-1">
    <v-row
      ><v-col class="mx-0 pa-0" style="position: relative">
        <div style="position: absolute; top: 0; left: 0; width: 100%">
          <div
            style="border-radius: 0 0 40% 40% / 0 0 40px 40px; overflow: hidden"
            :style="{
              height: ['card', 'card_no_point'].includes(user_point_type)
                ? '200px'
                : '264px',
              background: `linear-gradient(120deg, ${site.color} 0%, ${darkColor} 100%)`,
              boxShadow: headerShadow,
            }"
          ></div>
        </div>

        <AccountDetailWidget
          v-if="['default', 'default_no_point'].includes(user_point_type)"
          :user_point_type="user_point_type"
          :site="site"
          :customer="customer"
          :url="url"
          :dataExpireCoin="dataExpireCoin"
          @onFileUpload="onFileUpload"
        />
        <MemberCardWidget
          v-if="['card', 'card_no_point'].includes(user_point_type)"
          :user_point_type="user_point_type"
          :site="site"
          :customer="customer"
          :url="url"
          :dataExpireCoin="dataExpireCoin"
          @onFileUpload="onFileUpload"
        />
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-n6">
      <v-col cols="12" sm="8">
        <v-card outlined class="mx-4 my-6">
          <v-card
            class="d-flex px-4"
            elevation="0"
            :to="{ name: 'birthday-gift' }"
            v-if="isShowBirthdayGift"
          >
            <v-icon>mdi-cake</v-icon>
            <v-card-text>{{ $t("birthDayPage") }}</v-card-text>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
          <v-divider v-if="isShowBirthdayGift"></v-divider>

          <v-card
            class="d-flex px-4"
            elevation="0"
            :to="{ name: 'my-member' }"
            v-if="isShowMyMember"
          >
            <v-icon>mdi-account-group-outline</v-icon>
            <v-card-text>{{ $t("myMemberPage") }}</v-card-text>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
          <v-divider v-if="isShowMyMember"></v-divider>

          <div v-for="(item, index) in menu" :key="index">
            <div v-if="item.display == 'true' || item.display == true">
              <v-card class="d-flex px-4" elevation="0" :to="{ name: item.to }">
                <v-icon>{{ item.icon }}</v-icon>

                <v-card-text>{{ item.name }}</v-card-text>
                <span
                  v-if="item.to == 'my-coupons' && totalCoupon > 0"
                  class="mt-3"
                >
                  <v-chip small class="text-capitalize mt-1" color="red" dark>
                    {{ totalCoupon | commaPoint }}
                  </v-chip>
                </span>
                <v-icon>mdi-chevron-right</v-icon>
              </v-card>
              <v-divider></v-divider>
            </div>
          </div>

          <v-card
            class="d-flex px-4"
            elevation="0"
            :to="{ name: 'invite-friend' }"
            v-if="
              site.is_use_invite == 'Y' && site.account_type == 'individual'
            "
          >
            <v-icon>mdi-account-plus-outline</v-icon>
            <v-card-text>{{ $t("invitePage") }}</v-card-text>
            <v-icon>mdi-chevron-right</v-icon>
          </v-card>
          <v-divider
            v-if="
              site.is_use_invite == 'Y' && site.account_type == 'individual'
            "
          ></v-divider>

          <div v-if="partnerList.length > 0">
            <v-card
              class="d-flex px-4"
              elevation="0"
              @click="handleExpandPartner"
            >
              <v-icon>mdi-link-plus</v-icon>
              <v-card-text>
                <div>
                  <div>{{ $t("connectPlatformPage") }}</div>
                  <div
                    v-if="false"
                    style="color: #2196f3; font-size: 10px; line-height: 1"
                  >
                    {{ $t("connectPlatformPageHint") }}
                  </div>
                </div>
              </v-card-text>
              <v-icon>{{
                expandPartner ? "mdi-chevron-down" : "mdi-chevron-right"
              }}</v-icon>
            </v-card>
            <div v-if="expandPartner">
              <v-divider></v-divider>
              <v-card
                v-for="(item, index) in partnerList"
                :key="index"
                class="d-flex px-4 align-center"
                elevation="0"
                @click="handleClickConnectPlatform(item)"
              >
                <div
                  v-if="item.image"
                  class="d-flex justify-center align-center"
                  style="width: 24px; height: 24px"
                >
                  <img
                    :src="item.image"
                    style="width: 100%; object-fit: contain"
                  />
                </div>
                <v-card-text>
                  <div class="d-flex align-center">
                    {{ item.name }}
                    <div
                      v-if="item.connect_partner_status"
                      class="ml-2 d-flex align-center"
                      style="gap: 4px"
                    >
                      <v-icon
                        small
                        :color="
                          connectPartnerStatusColor(
                            item.connect_partner_status,
                            'color'
                          )
                        "
                        >{{
                          connectPartnerStatusColor(
                            item.connect_partner_status,
                            "icon"
                          )
                        }}</v-icon
                      >
                      <div
                        style="font-size: 10px"
                        :style="{
                          color: connectPartnerStatusColor(
                            item.connect_partner_status,
                            'color'
                          ),
                        }"
                      >
                        {{ item.connect_partner_status }}
                      </div>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </div>
          <!-- logout line -->
          <v-divider></v-divider>
          <v-card
            v-if="site.is_use_line == 'Y' && site.is_use_logout"
            class="d-flex px-4"
            elevation="0"
            @click="openConfirmLogoutLine = true"
          >
            <v-icon>mdi-trash-can-outline</v-icon>
            <v-card-text>{{ $t("removeCache") }}</v-card-text>
          </v-card>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <div
        class="d-flex align-center px-3"
        style="
          height: 32px;
          border-radius: 16px;
          background-color: #ffffffa6;
          border: 2px solid #ffffffcc;
        "
      >
        <p class="mb-0" style="color: gray">{{ $t("version") }} 3.0.0</p>
      </div>
    </v-row>

    <v-row justify="center" class="mt-10">
      <v-btn
        v-if="site.is_use_line != 'Y' && site.is_use_logout"
        @click="logout"
        color="red"
        outlined
        class="text-capitalize"
        style="background-color: #ffffff"
      >
        <span> {{ $t("logout") }} <v-icon>mdi-logout</v-icon> </span>
      </v-btn>
    </v-row>

    <Facebook />

    <!-- connect partner -->
    <v-dialog v-model="dialogConnectPartner" persistent max-width="320">
      <v-card>
        <v-container>
          <v-row>
            <v-col class="pb-0">
              <v-form ref="form" :v-model="true" lazy-validation>
                <v-card-text class="text-center pa-2" style="color: black">
                  <div
                    class="d-flex justify-center align-center mb-5"
                    style="height: 36px; gap: 8px; font-size: 20px"
                  >
                    <div style="font-weight: 700">{{ $t("connect") }}</div>
                    <div
                      class="pa-2 d-flex"
                      style="border-radius: 8px"
                      :style="{
                        color: `${getFontColorBasedOnBg(
                          dataPartner.color || '#000000',
                          'bw'
                        )} !important`,
                        'background-color': dataPartner.color || '#000000',
                      }"
                    >
                      {{ dataPartner.name }}
                      <div
                        v-if="dataPartner.image"
                        class="ml-2 d-flex justify-center align-center"
                        style="width: 24px; height: 24px"
                      >
                        <img
                          :src="dataPartner.image"
                          style="width: 100%; object-fit: contain"
                        />
                      </div>
                    </div>
                  </div>
                  <v-text-field
                    class="mt-2"
                    label="Order Number"
                    placeholder="Order Number"
                    v-model="inputOrderPartner"
                    outlined
                    dense
                    :rules="!statusOrderPartner ? normalRules : []"
                    :clearable="statusOrderPartner != 'success'"
                    :readonly="statusOrderPartner == 'success'"
                  ></v-text-field>
                </v-card-text>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="pb-5 pt-0">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="dialogConnectPartner = false"
          >
            {{ $t("close") }}
          </v-btn>
          <v-btn
            v-if="statusOrderPartner != 'success'"
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="handleConfirmConnectPartner()"
          >
            {{ $t("confirmDefault") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- confirm logout line -->
    <v-dialog v-model="openConfirmLogoutLine" persistent max-width="290">
      <v-card>
        <v-container>
          <v-row>
            <v-col>
              <v-card-text class="text-center" style="color: black">
                {{ $t("instructionLineReopenExternalBrowser") }}
              </v-card-text>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions class="pb-5">
          <v-spacer></v-spacer>
          <v-btn
            :color="site.color"
            class="rounded-lg"
            outlined
            @click="openConfirmLogoutLine = false"
          >
            {{ $t("cancel") }}
          </v-btn>
          <v-btn
            :color="site.color"
            class="rounded-lg white--text"
            depressed
            @click="handleConfirmLogoutLine()"
          >
            {{ $t("confirm") }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div
      class="fab-container"
      :style="{
        'padding-bottom': showBottomNavbar ? '70px' : '0px',
      }"
    >
      <v-btn
        v-if="checkFloatPanel"
        fab
        dark
        :color="site.color"
        class="mr-6"
        @click="dialogFloatPanel = true"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </div>

    <FloatPanel
      :dialog="dialogFloatPanel"
      @onClose="dialogFloatPanel = false"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service";
import { adjustHslBrightness } from "@/config/general-function";
import { getFontColorBasedOnBg } from "@/config/general-function";
import AccountDetailWidget from "@/components/widget/account-detail.vue";
import MemberCardWidget from "@/components/widget/member-card.vue";
import FloatPanel from "@/components/floatPanel.vue";
import Facebook from "../../../components/socialMedia/facebook.vue";
import { connectLineUser } from "../../../config/line-service-login.js";

export default {
  name: "my-account",
  inject: ["isAppLoading"],
  components: { AccountDetailWidget, MemberCardWidget, FloatPanel, Facebook },
  data() {
    return {
      dialogFloatPanel: false,
      url: "",
      menu: [],
      totalCoupon: 0,
      openConfirmLogoutLine: false,
      darkColor: "",
      dataExpireCoin: [],
      partnerList: [],
      dataPartner: {},
      expandPartner: false,
      dialogConnectPartner: false,
      inputOrderPartner: "",
      statusOrderPartner: null,
      isShowBirthdayGift: false,
      isShowMyMember: false,
      user_point_type: "default",
    };
  },
  async created() {
    this.isAppLoading(true);
    this.isShowBirthdayGift = this.site?.show_birthday_gift_menu || false;
    this.isShowMyMember = ["multi_profile", "group_account"].includes(
      this.site?.account_type
    );
    this.user_point_type = this.site?.display_setting?.user_point || "default";
    this.darkColor = adjustHslBrightness(this.site.color, -30);
    await this.getMenuAccount();
    await this.getTotalCoupon();
    await this.getPartnerList();
    await this.getExpireCoin();
    this.isAppLoading(false);
  },
  async mounted() {
    if (this.customer) {
      this.url = this.customer.image;
    }
  },
  methods: {
    async getMenuAccount() {
      this.menu = JSON.parse(this.site.menu_account);
    },
    async getTotalCoupon() {
      try {
        const response = await Axios.get("reward/getTotalCouponNotUse", {});
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          this.totalCoupon = dataResponse.data.total_coupon_not_use;
        }
      } catch (err) {
        this.$swal.fire({
          icon: "error",
          title: JSON.stringify(err?.response?.data?.message),
          showConfirmButton: false,
          timer: 3000,
        });
      }
    },
    async getPartnerList() {
      this.partnerList = [];
      // ========== ========== ========== ==========
      const isUseConnectLine = this.site.is_use_connect_line;
      if (isUseConnectLine && this.site.liff_id) {
        const detail = {
          id: 0,
          code: "LINE",
          name: "Line",
          image: require("@/assets/social/line-circle.svg"),
          deleted_at: null,
          created_at: null,
          updated_at: null,
          color: "#EF4E2E",
          type: "social",
          partner_code: "LINE",
          connect_partner_status: this.customer?.line_id ? "success" : null,
          connect_partner_order_number: null,
        };
        this.partnerList.push(detail);
      }
      // ========== ========== ========== ==========
      try {
        const response = await Axios.get("partner/getPartnerList", {
          params: {
            type: "ecommerce",
          },
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          if (Array.isArray(dataResponse.data)) {
            let connect_partner = [];
            if (this.site.connect_partner) {
              connect_partner = [...this.site.connect_partner];
            }
            let list = [...dataResponse.data];
            list = list.map((x) => {
              let detail = { ...x };
              const model = connect_partner.find(
                (c) => c.partner_code === detail.partner_code
              );
              detail.connect_partner_status = model?.status || null;
              detail.connect_partner_order_number = model?.order_number || null;
              return detail;
            });
            this.partnerList = [...this.partnerList, ...list];
          }
        }
      } catch (err) {
        console.log("getPartnerList", err);
      }
    },
    async getExpireCoin() {
      try {
        const response = await Axios.get("getExpirePoint");
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          this.dataExpireCoin = dataResponse.data.data;
          console.log("this.dataExpireCoin :>> ", this.dataExpireCoin);
        }
      } catch (err) {
        console.log("getExpireCoin", err);
      }
    },

    saveLogoImage(imageFile) {
      let formData = new FormData();
      formData.append("image", imageFile);
      Axios.post("uploadImageProfile", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.data.status == "success") {
            this.$swal.fire({
              icon: "success",
              title: this.$t("uploadSuccessful"),
              showConfirmButton: false,
              timer: 2000,
            });
            this.$store.dispatch("defaultSystem/getProfile");
          } else {
            this.$swal.fire(this.$t("error.title"), res.data.error, "error");
          }
        })
        .catch(() => {
          this.$swal.fire({
            icon: "error",
            text: this.$t("errSubmissionFailed"),
            showConfirmButton: false,
            timer: 2000,
          });
        });
    },
    onFileUpload(event) {
      const file = event.target.files[0];
      this.url = URL.createObjectURL(file);
      this.saveLogoImage(file);
    },

    async logout() {
      this.logoutAndClear();
    },
    logoutAndClear() {
      this.isAppLoading(true);

      Axios.post("logout")
        .then(() => {
          //
        })
        .catch((err) => {
          console.log("error:logoutAndClear", err);
        })
        .finally(() => {
          localStorage.clear();
          localStorage.setItem("is_logout", "1");
          setTimeout(() => {
            location.reload();
          }, 500);
        });
    },
    handleConfirmLogoutLine() {
      this.logout();
      this.openConfirmLogoutLine = false;
    },

    getFontColorBasedOnBg(param, param2) {
      const res = getFontColorBasedOnBg(param, param2);
      return res;
    },
    hexToRgb(hex) {
      const bigint = parseInt(hex.slice(1), 16);
      return {
        r: (bigint >> 16) & 255,
        g: (bigint >> 8) & 255,
        b: bigint & 255,
      };
    },
    darkenHexColor(hex, percentage) {
      // Convert Hex to RGB
      const { r, g, b } = this.hexToRgb(hex);

      // Darken the RGB values
      const factor = 1 - percentage / 100;
      const darkenedR = Math.max(0, Math.floor(r * factor));
      const darkenedG = Math.max(0, Math.floor(g * factor));
      const darkenedB = Math.max(0, Math.floor(b * factor));

      // Convert back to Hex
      const toHex = (value) => value.toString(16).padStart(2, "0");
      const darkenedHex = `#${toHex(darkenedR)}${toHex(darkenedG)}${toHex(
        darkenedB
      )}`;

      this.darkColor = darkenedHex;
    },

    handleExpandPartner() {
      this.expandPartner = !this.expandPartner;
    },
    async handleClickConnectPlatform(param) {
      if (param.partner_code == "LINE") {
        if (this.customer?.line_id) {
          return;
        }
        this.isAppLoading(true);
        const res = await connectLineUser();
        if (!res) {
          this.isAppLoading(false);
        }
        return;
      }
      this.dataPartner = { ...param };
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      this.inputOrderPartner = "";
      if (["success", "waiting"].includes(param?.connect_partner_status)) {
        this.inputOrderPartner = param.connect_partner_order_number;
      }
      console.log(param);
      this.statusOrderPartner = param.connect_partner_status;
      this.dialogConnectPartner = true;
    },
    async handleConfirmConnectPartner() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.isAppLoading(true);
      await this.connectPartner();
      this.dataPartner = {};
      this.dialogConnectPartner = false;
      this.isAppLoading(false);
    },
    async connectPartner() {
      try {
        const response = await Axios.post("partner/updateOrderEmployee", {
          partner_code: this.dataPartner.code,
          order_number: this.inputOrderPartner,
        });
        const dataResponse = response?.data;
        if (dataResponse?.status == "success") {
          await this.$store.dispatch("defaultSystem/getSiteTemplate");
          this.getPartnerList();
        } else {
          this.$swal.fire(
            this.$t("error.title"),
            dataResponse.message,
            "error"
          );
        }
      } catch (err) {
        console.log("connectPartner", err);
      }
    },
    connectPartnerStatusColor(status, type) {
      let data = "";
      if (status === "success") {
        data = type === "icon" ? "mdi-check-decagram-outline" : "#4CAF50";
      } else if (status === "waiting") {
        data = type === "icon" ? "mdi-history" : "#FF9800";
      } else if (status === "fail") {
        data = type === "icon" ? "mdi-alert-decagram-outline" : "#F44336";
      }
      return data;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site", "customer"]),
    normalRules() {
      return [(v) => !!v || this.$t("validation.required")];
    },
    headerShadow() {
      const { r, g, b } = this.hexToRgb(this.site.color);
      return `rgba(${r},${g},${b},0.4) 0px 5px, rgba(${r},${g},${b},0.3) 0px 10px, rgba(${r},${g},${b},0.2) 0px 15px, rgba(${r},${g},${b},0.1) 0px 20px, rgba(${r},${g},${b},0.05) 0px 25px`;
    },
    showBottomNavbar() {
      let check = false;
      // ========== ========== ========== ==========
      let checkInRoute = true;
      const curRouteName = this.$route.name;
      let listRouteName = [];
      if (
        Array.isArray(this.site?.bottom_nav_bar?.menu) &&
        this.site?.bottom_nav_bar?.menu?.length > 0
      ) {
        const listRouteAllow = this.site?.bottom_nav_bar.menu.map(
          (x) => x.route_allow
        );
        for (let item of listRouteAllow) {
          listRouteName = [...listRouteName, ...item];
        }
      }
      if (listRouteName.length > 0 && !listRouteName.includes(curRouteName)) {
        checkInRoute = false;
      }
      // ========== ========== ========== ==========
      if (this.site.is_use_bottom_nav && checkInRoute) {
        check = true;
      }
      return check;
    },
    checkFloatPanel() {
      let check = false;
      if (this.site.is_use_float_panel) {
        const float_panel_main_menu = this.site.float_panel_main?.menu || [];
        const float_panel_extend_menu =
          this.site.float_panel_extend?.menu || [];
        const model_main_all_open = float_panel_main_menu.find((x) => x.show);
        const model_extend_all_open = float_panel_extend_menu.find(
          (x) => x.show
        );
        if (model_main_all_open || model_extend_all_open) {
          check = true;
        }
      }
      return check;
    },
  },
  filters: {
    commaPoint(value) {
      // comma point number to baht
      if (value == 0) {
        return "0";
      } else if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
};
</script>

<style scoped>
.fab-container {
  position: fixed;
  bottom: 16px;
  right: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  z-index: 1;
}
</style>
